import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  grupoFiltros: {
    marginBottom: theme.spacing(1),
  },
  grupoTitle: {
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    fontSize: '0.75rem',
    borderBottom: `2px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(0.5),
  },
  field: {
    marginTop: theme.spacing(2),
  },
  itemData: {
    marginTop: theme.spacing(3),
  },
}))

export default useStyles
